var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisaLogo = function SvgVisaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.667,
    height: 31,
    rx: 4.833,
    fill: "#fff",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.167 21.678H11.34L9.22 13.59c-.1-.372-.314-.701-.629-.856A9.203 9.203 0 0 0 6 11.878v-.312h4.554c.629 0 1.1.468 1.179 1.011l1.1 5.835 2.825-6.845h2.749l-4.24 10.11Zm5.811 0h-2.67l2.199-10.112h2.67l-2.199 10.112Zm5.653-7.31c.079-.545.55-.856 1.1-.856a4.974 4.974 0 0 1 2.591.466l.472-2.177a6.758 6.758 0 0 0-2.434-.468c-2.592 0-4.477 1.4-4.477 3.345 0 1.478 1.335 2.255 2.278 2.723 1.02.466 1.413.777 1.334 1.244 0 .7-.785 1.01-1.57 1.01-.942 0-1.885-.233-2.748-.622l-.472 2.178c.943.389 1.963.545 2.906.545 2.906.077 4.711-1.323 4.711-3.423 0-2.644-3.69-2.8-3.69-3.965Zm13.036 7.31-2.12-10.112H34.27c-.472 0-.943.312-1.1.778l-3.926 9.334h2.748l.55-1.478h3.376l.315 1.478h2.434Zm-4.005-7.389.785 3.811h-2.199l1.414-3.81Z",
    fill: "#172B85"
  })));
};
export default SvgVisaLogo;